import { render } from "./DocumentDetailsVisibilityConditions.vue?vue&type=template&id=3a18cb25&scoped=true&ts=true"
import script from "./DocumentDetailsVisibilityConditions.vue?vue&type=script&lang=ts"
export * from "./DocumentDetailsVisibilityConditions.vue?vue&type=script&lang=ts"

import "./DocumentDetailsVisibilityConditions.vue?vue&type=style&index=0&id=3a18cb25&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a18cb25"]])

export default __exports__